import { createAction, props } from "@ngrx/store";
import { GameStateId } from "../game/game.state";

export const displayRequestsAction = createAction(
    'DISPLAY_REQUESTS',
    props<{
        gameStateId: GameStateId;
    }>()
);

export const displayCounterAction = createAction(
    'DISPLAY_COUNTER',
    props<{
        gameStateId: GameStateId;
    }>()
);

export const displayInfoAction = createAction(
    'DISPLAY_INFO',
    props<{
        gameStateId: GameStateId;
    }>()
);

export const removeActiveTab = createAction(
    'REMOVE_ACTIVE_TAB',
    props<{
        gameStateId: GameStateId;
    }>()
);
